export default __webpack_public_path__ + "static/media/equipment.9df5be35.svg";